// Email service using EmailJS
// You'll need to sign up at https://www.emailjs.com/ and get your service ID, template ID, and public key
import emailjs from '@emailjs/browser';

const EMAILJS_SERVICE_ID = 'service_5qnjhu9'; // Your EmailJS service ID
const EMAILJS_TEMPLATE_ID = 'template_ias3gc9'; // Your EmailJS template ID
const EMAILJS_PUBLIC_KEY = 'FpVs16aoqDLB9l7w6'; // Your EmailJS public key

// Check if EmailJS is properly configured
const isEmailJSConfigured = () => {
  return EMAILJS_SERVICE_ID === 'service_5qnjhu9' && 
         EMAILJS_TEMPLATE_ID === 'template_ias3gc9' && 
         EMAILJS_PUBLIC_KEY === 'FpVs16aoqDLB9l7w6';
};

// Initialize EmailJS
const initEmailJS = () => {
  if (isEmailJSConfigured()) {
    emailjs.init(EMAILJS_PUBLIC_KEY);
  }
};

// Temporary fallback function for when EmailJS is not configured
const sendEmailFallback = async (formData, type) => {
  console.log(`📧 ${type} Form Submission:`, {
    to: 'yagnikpokal@gmail.com, business@octalchip.com',
    from: formData.email || formData.from_email,
    subject: `${type} Form Submission`,
    data: formData
  });
  
  // Simulate email sending delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  return {
    success: true,
    message: `${type} submitted successfully! We'll get back to you soon.`,
    data: { method: 'fallback', formData }
  };
};

// Send contact form email
export const sendContactFormEmail = async (formData) => {
  try {
    // If EmailJS is not configured, use fallback
    if (!isEmailJSConfigured()) {
      return await sendEmailFallback(formData, 'Contact');
    }

    // Initialize EmailJS if not already done
    initEmailJS();
    
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      from_phone: formData.phone,
      message: formData.message,
      to_email: 'yagnikpokal@gmail.com, business@octalchip.com', // Multiple recipients
      subject: `New Contact Form Submission from ${formData.name}`,
    };

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    return {
      success: true,
      message: 'Email sent successfully!',
      data: response
    };
  } catch (error) {
    console.error('Error sending email:', error);
    return {
      success: false,
      message: 'Failed to send email. Please try again.',
      error: error.message
    };
  }
};

// Send requirements form email
export const sendRequirementsFormEmail = async (formData) => {
  try {
    // If EmailJS is not configured, use fallback
    if (!isEmailJSConfigured()) {
      return await sendEmailFallback(formData, 'Requirements');
    }

    // Initialize EmailJS if not already done
    initEmailJS();
    
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      from_phone: formData.phone,
      project_type: formData.projectType,
      requirements: formData.requirements,
      to_email: 'yagnikpokal@gmail.com, business@octalchip.com',
      subject: `New Project Requirements from ${formData.name}`,
    };

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    return {
      success: true,
      message: 'Requirements submitted successfully!',
      data: response
    };
  } catch (error) {
    console.error('Error sending requirements email:', error);
    return {
      success: false,
      message: 'Failed to submit requirements. Please try again.',
      error: error.message
    };
  }
};

// Send newsletter subscription email
export const sendNewsletterSubscriptionEmail = async (email) => {
  try {
    // If EmailJS is not configured, use fallback
    if (!isEmailJSConfigured()) {
      return await sendEmailFallback({ email }, 'Newsletter');
    }

    // Initialize EmailJS if not already done
    initEmailJS();
    
    const templateParams = {
      subscriber_email: email,
      to_email: 'yagnikpokal@gmail.com, business@octalchip.com',
      subject: 'New Newsletter Subscription',
      message: `New newsletter subscription from: ${email}`,
    };

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    return {
      success: true,
      message: 'Newsletter subscription successful!',
      data: response
    };
  } catch (error) {
    console.error('Error sending newsletter email:', error);
    return {
      success: false,
      message: 'Failed to subscribe to newsletter. Please try again.',
      error: error.message
    };
  }
};

// Alternative: Simple fetch-based email service (if you have a backend API)
export const sendEmailViaAPI = async (formData, endpoint = '/api/contact') => {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        to: ['yagnikpokal@gmail.com', 'business@octalchip.com'],
        subject: `New Contact Form Submission from ${formData.name}`,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      return {
        success: true,
        message: 'Email sent successfully!',
        data
      };
    } else {
      throw new Error(data.message || 'Failed to send email');
    }
  } catch (error) {
    console.error('Error sending email via API:', error);
    return {
      success: false,
      message: 'Failed to send email. Please try again.',
      error: error.message
    };
  }
}; 